import * as React from 'react';
import { Card, Spin } from 'antd';
import { StackedAreaChart } from '../charts/StackedAreaChart';
import { getActiveSpendSources, SpendSourceDescriptor } from '../../utils/AnalyticsUtils';
import { getSpendBySourceMonthlyChartConfig } from '../../utils/SpendAnalyticsChartUtils';
import { ANALYTICS_CHART_TOOLTIP_ITEM_TPL } from '../analytics_charts/analyticsChartTooltipTemplates';

type SpendOverTimeChartProps = {
	// SpendCostsMonthly rows (string amounts) from spendCostsByMonth.data.
	monthlyData: any[];
	currency: any;
	loading?: boolean;
	// Restricts which sources can appear (e.g. invoice-only on the Suppliers tab). Defaults to all.
	allowedSources?: SpendSourceDescriptor[];
};

// Monthly "Spend over time" stacked-area chart split by spend source. Shared by the three spend
// overview tabs (OPE-4875).
export const SpendOverTimeChart: React.FC<SpendOverTimeChartProps> = ({
	monthlyData,
	currency,
	loading = false,
	allowedSources,
}) => {
	const rows = monthlyData || [];
	const activeSources = getActiveSpendSources(rows, allowedSources);
	const config = getSpendBySourceMonthlyChartConfig(currency, activeSources);

	return (
		<Card title="Spend over time">
			<Spin spinning={loading}>
				{rows.length > 0 && activeSources.length > 0 ? (
					<StackedAreaChart
						height={260}
						chartPadding={[40, 40, 40, 80]}
						data={config.transformer(rows)}
						tooltipItemTemplate={ANALYTICS_CHART_TOOLTIP_ITEM_TPL}
						showTooltipTitle={false}
						fillArea={false}
						xAxisName={config.xAxisName}
						yAxisName={config.yAxisName}
						yAxisLabel={config.yAxisLabel}
						xAxisLabel={config.xAxisLabel}
						cols={config.cols}
						color={config.color}
						position={config.position}
					/>
				) : null}
			</Spin>
		</Card>
	);
};
